import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { hasRole } from "../config/roles";

interface RouteAuthProps {
  children: ReactNode;
  role?: string;
}

const RouteAuth = ({ children, role = "user" }: RouteAuthProps) => {
  const { userInfo } = useAuthStore();

  const isAuthenticated = () => {
    if (userInfo && hasRole(userInfo.role, role)) return true;
    return false;
  };

  return isAuthenticated() ? <>{children}</> : <Navigate to="/account/login" replace />;
};

export default RouteAuth;
